"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/** ****************************************************************************
 * Component
 **************************************************************************** */
var ChatImagePreview = function ChatImagePreview(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      url = _ref.url;
  return /*#__PURE__*/_react["default"].createElement("img", {
    className: (0, _classnames["default"])(classes.root, className),
    src: url,
    alt: "preview"
  });
};

ChatImagePreview.propTypes = {
  classes: _propTypes["default"].object,
  className: _propTypes["default"].string,
  url: _propTypes["default"].string
};
ChatImagePreview.defaultProps = {
  className: ''
};
/** ****************************************************************************
 * Styles
 **************************************************************************** */

var styles = function styles(theme) {
  return {
    root: {
      width: '100%',
      objectFit: 'cover',
      // padding: theme.spacing.unit * 2,
      paddingBottom: theme.spacing.unit
    }
  };
};

var _default = (0, _styles.withStyles)(styles)(ChatImagePreview);

exports["default"] = _default;